import React from "react";
import PageLayout from "../../components/PageLayout";
import { FirstOrderTrendOptions, RankTrendOptions, ReOrderTrendOptions, VolumeTrendOptions } from "../Reports/TrendsConfig";
import WishCard from "../../components/WishCard";
import WishModal from "../../components/WishModal";
import EmptyAnimation from "../../components/EmptyAnimation";
import animation from "../../assets/app-assets/images/lottie/NoDataAvailable.json";

export default function EventsDash() {
  const distributor = JSON.parse(localStorage.getItem("distributor"));
  console.log("distributor", distributor);
  const breadcrumbs = [];
  breadcrumbs.push({ title: "Home", linkTo: "/" });


  const publicReports = [
   
    {
      title: "Marketting Collaterals download",
      icon: "la-chart-line",
      line1: "You can now download all posters, videos, and other marketing collateral materials.",
      linkToModal: "#dlgMarkettingCollaterals",

    },
  ];



  const reportsNotYetReleased = [];
  return (
    <PageLayout activeSideMenu="10" pageTitle="Marketting Collaterals" header="Marketting Collaterals" breadcrumbs={breadcrumbs}>
      <section className="row">
        {publicReports.map((card, index) => (
          <div className="col-md-4 col-sm-6" key={index}>
            <WishCard
              title={card.title}
              icon={card.icon}
              line1={card.line1}
              line2={card.line2}
              linkToState={card.linkToState}
              linkTo={card.linkTo}
              maxHeight={true}
              linkToModal={card.linkToModal}
            ></WishCard>
          </div>
        ))}

      </section>
      <WishModal
        id="dlgMarkettingCollaterals"
        title="Download Marketing Collaterals"
        hideCancelButton={true}
        noFooter={true}
        finishTitle="Proceed"
        modalSize="modal-md"
      >
        <p>Dear Distributors,</p>
        <p>
          We are pleased to inform you that the Marketing Collateral Download feature is now enabled. You can now easily download all posters, videos, and other marketing materials.
        </p>
        <p>Please follow the steps below to access and download the collaterals:</p>
        <ul>
          <li>This feature is developed on a different application, so you will need to log in separately using the credentials provided below.</li>
          <li>Once you click the login button, a login popup will appear where you need to enter your username and password.</li>
        </ul>
        <p>
          <strong>Username: {distributor.distributor_id}@indusviva.com</strong><br />
          <strong>Password: Your existing Virtual Office password</strong>
        </p>
        <p>👉 <strong>Make sure you are entering the correct username and password to access the site.</strong></p>

        <button
          className="btn btn-primary float-right"
          onClick={() => window.open('http://digital.indusviva.com', '_blank')}
        >
          Log In
        </button>
      </WishModal>

    </PageLayout>
  );
}
